import { ReportContextDisplay } from '../ReportContext';
import { Files } from './Attachments';
import type { TicketDetail } from '../../../api/ticket-types';
import { Markdown } from '../../../ui/Markdown';
import { Card } from '../../../ui/misc';
import { AssistantPanel } from '../AssistantPanel';
import { Relationships } from './Relationships';

export function Overview({ t }: { t: TicketDetail }) {
  return (
    <>
      <Card title="Description">
        {t.description.trim() ? (
          <Markdown>{t.description}</Markdown>
        ) : (
          <span className="small muted">No description provided.</span>
        )}
        <ReportContextDisplay value={t} />
        {t.stepsOrOutcome && (
          <>
            <h3 className="title-sm">{t.type === 'issue' ? 'Reproduction steps' : 'Intended outcome'}</h3>
            <Markdown>{t.stepsOrOutcome}</Markdown>
          </>
        )}
      </Card>
      <Card
        title="Acceptance criteria"
        subtitle={
          t.status === 'pending'
            ? 'Proposed. Finalized when an admin accepts this scope.'
            : `Accepted at scope revision ${t.scopeRevision}.`
        }
      >
        {t.acceptanceCriteria.length ? (
          <ol style={{ margin: 0, paddingLeft: 20 }} className="stack sm">
            {t.acceptanceCriteria.map((c, i) => (
              <li key={i}>
                <Markdown>{c}</Markdown>
              </li>
            ))}
          </ol>
        ) : (
          <span className="small muted">No criteria yet. They are required before acceptance.</span>
        )}
      </Card>
      {t.attachments.some((a) => !a.commentId && !a.removedAt) && <Files t={t} />}
      <AssistantPanel projectKey={t.project.key} number={t.number} ticketVersion={t.version} />
      <Relationships t={t} />
    </>
  );
}
